import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {useEffect, useState} from 'react'
import { scroller } from 'react-scroll';
import styled from 'styled-components';
import theme from '../../themes';
import { Marginer } from '../marginer';
import {useWindowScroll} from 'react-use'



const TopContainer = styled.div`
position:fixed;
bottom:125px;
right:35px;
color:${theme.white};
background-color:${theme.primary};
padding:10px;
border-radius:10px;


:hover{
    cursor: pointer;

}




@media screen and (max-width:480px){
    position:fixed;
    bottom:90px;
    right:35px;
    
}
`;

const TopContainerIcon = styled.div`
animation: scrollTop 0.5s alternate ease infinite;

@keyframes scrollTop{
    from {
        transform: translateY(2px);
    }
    to{
        transform:translateY(-1px);
    }
}

`;


export function BackToTop(){

const {y : pageYOffset} = useWindowScroll();
const [visible, setVisible] = useState(false);

useEffect(()=>{
    if(pageYOffset > 800){
        setVisible(true)
    }else{
        setVisible(false)
    }
},[pageYOffset]);

const backToTop = ()=>window.scrollTo({top: 0, behavior:"smooth"})

if(!visible){
    return false;
}
    // const ToTop = ()=>{
    //     scroller.scrollTo("homepage",{smooth:true,duration:"700"})
    // }
    return(
    <TopContainer onClick={backToTop}>
    <TopContainerIcon>
        <FontAwesomeIcon icon={faArrowUp}/>
    </TopContainerIcon>
    </TopContainer>
        )

}
